import { useCallback, useEffect, useState } from 'react'
import { adminService } from '@/services/adminService'
import type { AdminUserListItem } from '@/types/admin'

interface UseAdminUsersResult {
  users: AdminUserListItem[]
  loading: boolean
  error: string | null
  reload: () => Promise<void>
}

/**
 * Loads the full user list for the admin interface.
 * Page-local state — no store needed (only used by AdminUsersPage).
 */
export function useAdminUsers(): UseAdminUsersResult {
  const [users, setUsers] = useState<AdminUserListItem[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const reload = useCallback(async () => {
    setLoading(true)
    setError(null)
    try {
      setUsers(await adminService.listUsers())
    } catch (err) {
      console.error('Failed to load admin user list:', err)
      setError('Kunde inte hämta användare. Försök igen senare.')
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    reload()
  }, [reload])

  return { users, loading, error, reload }
}
